import { render, staticRenderFns } from "./lookPaper.vue?vue&type=template&id=0469d909&scoped=true"
import script from "./lookPaper.vue?vue&type=script&lang=js"
export * from "./lookPaper.vue?vue&type=script&lang=js"
import style0 from "./lookPaper.vue?vue&type=style&index=0&id=0469d909&prod&scoped=true&lang=css"
import style1 from "./lookPaper.vue?vue&type=style&index=1&id=0469d909&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0469d909",
  null
  
)

export default component.exports